/* eslint-disable */
import { AUTH_STATE_CHANGED, AUTH_STATE_CHANGED_COMPLETE, AUTH_STATE_CHANGED_ERROR, AUTH_STATE_CHANGED_NEXT } from '../Auth.types';

/**
 * Watch for auth state changes and fire the appropriate actions
 * @param {CallbackFunction} callback A `callback` to be invoked upon calls from the observable callback
 * @returns {ActionCreator<FromObservableCallback<AuthEntity | null, Error, {}, AUTH_STATE_CHANGED, AUTH_STATE_CHANGED_COMPLETE, AUTH_STATE_CHANGED_ERROR, AUTH_STATE_CHANGED_NEXT>>} A Function to stop listening to the Observable
 */
const authOnAuthStateChanged = (callback) => ({ authService, fromObservableCallback }) => {
  return fromObservableCallback(authService.onAuthStateChanged, callback, {}, [
    AUTH_STATE_CHANGED,
    AUTH_STATE_CHANGED_COMPLETE,
    AUTH_STATE_CHANGED_ERROR,
    AUTH_STATE_CHANGED_NEXT,
  ]);
};

export default authOnAuthStateChanged;
